import * as authService from "./authentication.service";
import { getService } from "../../clients/feathers.clients";
import {
  IBannersFind,
  IPaymentConfirmationsFin,
  IProductCategoriesFin,
  IProductCharacteristics2Fin,
  IProductCharacteristicsFin,
  IRankingsFind,
} from "../../redux/@types";
import Service from "./service.class";

//authenticate
export const authenticationService = authService;
//services
export const usersService = new Service<any>(getService("users"));
export const addressesUsersService = new Service<any>(getService("addresses"));
export const productCharacteristicsService =
  new Service<IProductCharacteristicsFin>(getService("characteristics"));
export const productCategoriesService = new Service<IProductCategoriesFin>(
  getService("categories")
);
export const rankingsService = new Service<IRankingsFind>(
  getService("reviews")
);
export const bannersService = new Service<IBannersFind>(getService("banners"));
export const bannerProductsService = new Service<any>(
  getService("banner-products")
);
export const productsService = new Service<any>(getService("products"));
export const productCharacteristics2Service =
  new Service<IProductCharacteristics2Fin>(
    getService("products-characteristics")
  );
export const ordersService = new Service<any>(getService("orders"));

//TODO: si se implementa el servicio en el backend poner el nombre que le corresponde aquí abajo....
export const taxService = new Service<any>(getService("tax-rule"));
export const systemVariablesService = new Service<any>(
  getService("configurations")
);
export const citiesService = new Service<any>(getService("locations-cities"));
export const statesService = new Service<any>(getService("locations-states"));
export const storesService = new Service<any>(getService("stores"));
export const brandsService = new Service<any>(getService("brands"));
export const kitsService = new Service<any>(getService("kits"));
export const kitsProductsService = new Service<any>(
  getService("kits-products")
);
export const campaignsService = new Service<any>(getService("campaigns"));
export const campaignProductsService = new Service<any>(
  getService("campaign-products")
);
export const discountsService = new Service<any>(getService("discounts"));
export const priceListService = new Service<any>(getService("price-list"));
export const contactsDirectoryService = new Service<any>(
  getService("contacts-directory")
);
export const contactsDirectoryCategories = new Service<any>(
  getService("contacts-directory-categories")
);
export const contactsDirectoryAttributes = new Service<any>(
  getService("contacts-directory-attributes")
);
export const contactsDirectoryMedia = new Service<any>(
  getService("contacts-directory-media")
);
export const walletBonusService = new Service<any>(getService("wallet-bonus"));
export const walletMovementsService = new Service<any>(
  getService("wallet-movements")
);
export const coursesCategoriesService = new Service<any>(
  getService("courses-categories")
);
export const coursesService = new Service<any>(getService("courses"));
export const courseSectionsService = new Service<any>(
  getService("course-sections")
);
export const courseChaptersService = new Service<any>(
  getService("course-chapters")
);
export const courseBenefitsService = new Service<any>(
  getService("course-benefits")
);
export const cMSService = new Service<any>(getService("cms"));
export const workOffersCategoriesService = new Service<any>(
  getService("work-offers-categories")
);
export const workOffersService = new Service<any>(getService("work-offers"));
export const fulfillmentCompanyService = new Service<any>(
  getService("fulfillment-company")
);
export const fulfillmentCitiesService = new Service<any>(
  getService("fulfillment-cities")
);
export const fulfillmentMatrixService = new Service<any>(
  getService("fulfillment-matrix")
);
export const listCustomerGroupsService = new Service<any>(
  getService("customer-group")
);
export const listCustomersService = new Service<any>(
  getService("customer-group-customers")
);
export const priceListsService = new Service<any>(getService("price-list"));
export const configurationCashbackService = new Service<any>(
  getService("configuration-cashback")
);
export const cashbackReportService = new Service<any>(
  getService("cashback-report")
);

export const shippingService = new Service<any>(getService("shipping"));
export const shippingQuantityService = new Service<any>(
  getService("shipping-details")
);
export const ordersDetailsService = new Service<any>(
  getService("orders-details")
);
export const paymentConfirmationsService =
  new Service<IPaymentConfirmationsFin>(getService("payment-confirmations"));
export const taxRuleService = new Service<any>(getService("tax-rule"));
export const productMediaService = new Service<any>(
  getService("products-media")
);
export const orderStatusService = new Service<any>(getService("orders-status"));
export const programsAcademy = new Service<any>(getService("ca-programs"));
export const programsModuleAcademy = new Service<any>(
  getService("ca-program-modules")
);
export const programsTopicsAcademy = new Service<any>(
  getService("ca-program-module-topics")
);
export const programsModuleTechniquesAcademy = new Service<any>(
  getService("ca-program-module-techniques")
);
export const programsStudentAcademy = new Service<any>(
  getService("ca-program-students")
);
export const programsTeacherAcademy = new Service<any>(
  getService("ca-program-teacher")
);
export const programsStudentModuleTechniqueAcademy = new Service<any>(
  getService("ca-program-student-module-techniques")
);
export const programsModfuleTechniqueAcademy = new Service<any>(
  getService("ca-program-module-techniques-techniques")
);
export const programPaymenAcademy = new Service<any>(
  getService("ca-program-payments")
);
export const programPaymentScheduleAcademy = new Service<any>(
  getService("ca-program-payment-schedule")
);
export const academyEquipmentsService = new Service<any>(
  getService("rent-equipments")
);
export const academyEquipmentRentsService = new Service<any>(
  getService("rent-equipment-students")
);
export const programPaymentScheduleStudentAcademy = new Service<any>(
  getService("ca-student-payment-schedules")
);
export const studentProgramAssistancesAcademy = new Service<any>(
  getService("ca-student-program-assistances")
);
export const exportToExcelService = new Service<any>(
  getService("export-to-excel")
);
export const caSyncErrorsService = new Service<any>(
  getService("ca-sync-errors")
);
export const jobSyncCaPaymentsService = new Service<any>(
  getService("job-sync-ca-payments")
);
export const ipAccessRulesService = new Service<any>(
  getService("ip-access-rules")
);
export const securityAttemptsService = new Service<any>(
  getService("security-attempts")
);
//s3 SERVICES
export const s3FileUploadService = new Service(getService("s3Client"));
// export const usersService = app.service('users')
